module.exports = __webpack_public_path__ + "img/tekwill.1c3f152d.png";